<template>
  <div v-show="!showIfram" class="deposit">
    <div class="content" v-if="show">
      <div class="title">
        <div class="left-text">{{ $t('deposit.title') }}</div>
        <div @click="onClose" class="close_black" />
      </div>
      <div v-if="payStatus == 'PAY_SUCCESS' || payStatus == 2" class="dw_qr t_center">
        <h2 style="color: #009944">
          {{ formatMoney(payAmount) }} {{ unitConversion(balance.currencyAlias) }}
        </h2>
        <p>{{ $t('deposit.success') }}</p>
        <div class="btn_dw_yellow btn_100" @click="onClose">Play Now</div>
      </div>
      <div v-else-if="payStatus == 'PAY_INVALID' || payStatus == 3" class="dw_qr t_center">
        <p style="color: #ff0000 !important">
          Deposit {{ formatMoney(payAmount) }} {{ unitConversion(balance.currencyAlias) }} Failed
        </p>
        <p>{{ qureypaymsg }}</p>
        <div class="btn_dw_yellow btn_100" @click="tryagain">
          {{ $t('message.tryAgain') }}
        </div>
      </div>
      <div v-else-if="payStatus == 'PAY_PADING'" class="dw_qr t_center">
        <!-- <p style="color: #ceb45f !important">
          Deposit {{ formatMoney(currentAmount) }}
          {{ unitConversion(balance.currencyAlias) }} Pading
        </p> -->
        <p>{{ $t('message.padding') }}</p>
        <p>{{ $t('message.paddingtips') }}</p>
        <!-- <p>Tom Clancy's Rainbow Six Siege General Discussions.</p> -->
        <div class="btn_dw_yellow btn_100" @click="tryagain">
          {{ $t('message.tryAgain') }}
        </div>
      </div>
      <div v-else-if="!showQRInfo" style="width: 100%">
        <div v-if="!showWait">
          <div class="while-card">
            <PaymentMethod :updateData="onUpdatePayMethod" from="deposit" />
            <div class="dw-title">{{ $t('deposit.choose') }}</div>
            <div class="choose_amount">
              <div
                :class="!isFocus && select == index ? 'amount_active' : ''"
                v-for="(item, index) in listData"
                :key="index"
                @click="onSelectAmount(item, index)"
              >
                <li>
                  <i v-if="item.hot">{{ $t('deposit.hot') }}</i>
                  <div
                    v-if="
                      item.rechargeConfig &&
                      parseInt(item.amount) >= parseInt(item.rechargeConfig.minimumRecharge)
                    "
                    class="first-deposit"
                  >
                    {{ formatRechargeName(item.rechargeCount) }}
                  </div>
                  <h2
                    :style="
                      item.bonus > 0 ||
                      (item.rechargeConfig.rewardType == 2 &&
                        parseInt(item.rechargeConfig.maximumReward) > 0)
                        ? `margin: ${item.hot ? -0.05 : 0}rem 0`
                        : `margin: ${item.hot ? 0.1 : 0.2}rem 0`
                    "
                  >
                    {{ formatMoney(item.amount) }}
                  </h2>
                  <h3
                    v-if="
                      item.bonus > 0 ||
                      (item.rechargeConfig.rewardType == 2 &&
                        parseInt(item.rechargeConfig.maximumReward) > 0)
                    "
                  >
                    {{ $t('deposit.bonus') }}
                    {{
                      formatMoney(
                        Math.min(
                          item.rechargeConfig.maximumReward,
                          Math.round(
                            (Number(item.amount) * Number(item.rechargeConfig.rewardPercent)) / 100
                          )
                        )
                      )
                    }}
                  </h3>
                </li>
              </div>
            </div>
            <div class="dw-title" style="margin-bottom: -0.3rem">{{ $t('deposit.amount') }}</div>
            <div class="inputbox">
              <input
                name="amount"
                :type="inputType"
                :placeholder="$t(`deposit.limitMin.${country}`)"
                v-model="inputAmount"
                @focus="onFocus"
                @blur="onBlur"
                @input="onInput"
                autocomplete="off"
              />
            </div>
            <div class="error-message">
              <i v-if="errMsg && errMsg.length > 0" class="bi bi-x-circle-fill">&nbsp;</i>
              {{ errMsg }}
            </div>
          </div>
          <div class="dw_con" v-if="listData.length > 0">
            <div @click="onRecharge" v-if="btnState == 0" class="btn_dw_yellow btn_100">
              {{ $t('deposit.recharge') }}
              {{
                select > -1
                  ? formatMoney(listData[select].amount)
                  : formatMoney(removeThousandSeparatorWithDecimal(inputAmount))
              }}&nbsp;{{ unitConversion(balance.currencyAlias) }}&nbsp;
              {{ getCurrentBonus() }}
            </div>

            <div @click="onTest" v-else-if="btnState == 1" class="btn_dw_yellow btn_100">
              {{ $t('deposit.initiatewithdrawal') }}
            </div>

            <div v-else-if="btnState == 2" class="btn_dw_grey btn_100">
              {{ $t('deposit.initiatewithdrawal') }}
            </div>

            <div v-else class="btn_dw_yellow2 btn_100">
              <img :src="`${resBaseUrl}loading.gif`" />
            </div>
          </div>
        </div>
        <div v-else class="om_comtent">
          <div class="om_title">{{ $t('deposit.payer') }} {{ getPayerPar() }}</div>
          <div class="om_amount">{{ $t('deposit.currentrechargeamount') }}</div>
          <div class="om_amount" style="color: #009944; font-size: 0.5rem">
            {{ fee }}{{ unitConversion(balance.currencyAlias) }}
          </div>
          <div v-if="bankCode == 'OM_CI' || from == 'first_deposit_popup'" class="om_code">{{ $t('deposit.omcode') }}</div>
          <div v-else class="om_tips">
            {{ $t('deposit.waittips') }}
          </div>
          <div v-if="bankCode == 'OM_CI' || from == 'first_deposit_popup'" class="om_inputbox">
            <input
              name="amount"
              type="text"
              placeholder="OM CODE"
              v-model="omCode"
              autocomplete="off"
            />
          </div>
          <div v-if="bankCode == 'OM_CI' || from == 'first_deposit_popup'" class="om_btngroup">
            <div class="om_help" @click="showHelp = true">{{ $t('deposit.help') }}</div>
            <div
              :class="omCode.length > 0 ? 'om_active_confirm' : 'om_confirm'"
              @click="onConfitmer"
            >
              {{ $t('deposit.confirm') }}
            </div>
          </div>
          <div
            v-else
            :class="enableviewtransaction ? 'transaction_btn' : 'grey_transaction_btn'"
            @click="gototrancation"
          >
            {{ $t('deposit.viewtransaction') }}
            {{ !enableviewtransaction ? `${enableviewtransactionCD}s...` : '' }}
          </div>
        </div>
      </div>
      <div v-else style="width: 100%">
        <div class="dw_qr">
          <p>
            Abra o aplicativo do seu banco e escolha para pagar viaPix Copia e Cola ou via QR
            Code.<br /><br />
            Instruções para pagamento1. <br /><br />
            Copie o Código ID2. <br /><br />
            Certique de usar o código ID para finalizar o pagamento via PIX no aplicativo do seu
            banco
          </p>
          <br />
          <p class="t_center">
            <!-- <img :src="`${resBaseUrl}QR.png`" class="on_center" /> -->
            <QRCodeVue :value="qrCode" :margin="5" :size="150" level="M" class="on_center" />
          </p>
        </div>
        <div class="dw_amount">
          <li>
            <p>{{ $t('deposit.rechargeamount') }}</p>
            <h2>{{ currentAmount }}</h2>
          </li>
          <li>
            <p>{{ $t('deposit.receivedamount') }}</p>
            <h2>{{ currenReceived }}</h2>
          </li>
        </div>
        <div class="dw_con" @click="onCopiar">
          <div class="btn_dw_yellow btn_100">{{ $t('deposit.copiar') }}</div>
        </div>
      </div>
    </div>
    <van-popup
      class="popup_box"
      v-model:show="showHelp"
      round
      @click-overlay="showHelp = false"
      :transition-appear="true"
    >
      <div class="popup_title">{{ $t('deposit.helptitle') }}</div>
      <div class="popup_content">{{ $t('deposit.helpcontent') }}</div>
      <div class="popup_btn" @click="showHelp = false">{{ $t('deposit.valider') }}</div>
    </van-popup>
  </div>
  <iframe
    id="frame"
    v-show="showIfram"
    :src="iframUrl"
    style="width: 100%; height: 100vh"
    scrolling="no"
    frameborder="0"
  />
</template>

<script>
import { AIRBRIDEG_EVENT, airbrideg_report } from '@/common/airbridge'
import { config } from '@/common/config'
import { getLocalStorage, Key } from '@/common/localStorage'
import { REPORT_EVENT, reportGtag } from '@/common/mgtag'
import PaymentMethod from '@/components/PaymentMethodForCI.vue'
import { BUS, POPUP } from '@/event/EventCenter'
import SocketService from '@/server/socket'
import { useDepositStore } from '@/stores/deposit'
import { useUserStore } from '@/stores/user'
import {
  copy,
  currentPage,
  formatMoney,
  removeThousandSeparatorWithDecimal,
  setSEO,
  unitConversion
} from '@/utils/helper'
import { mapActions, mapState } from 'pinia'
import QRCodeVue from 'qrcode.vue'
import { closeToast, showFailToast, showLoadingToast } from 'vant'
export default {
  components: {
    QRCodeVue,
    PaymentMethod
  },
  props: {
    isInGame: {
      type: Boolean,
      default: false
    },
    from: {
      type: String,
      default: 'deposit'
    },
    callback: {
      type: Function,
      default: () => {}
    }
  },
  watch: {
    from(val) {
      if (val == 'first_deposit_popup') {
        this.showWait = true
      }
    }
  },
  data() {
    return {
      show: false,
      isFocus: false,
      select: 0,
      resBaseUrl: config.resBaseUrl,
      btnState: 0,
      listData: [],
      inputAmount: '',
      showQRInfo: false,
      qrCode: '',
      currentAmount: 0,
      currenReceived: 0,
      statusTimer: null,
      payChannel: '',
      bankCode: '',
      routing: '',
      omCode: '',
      showIfram: false,
      iframUrl: '',
      payStatus: '',
      payAmount: 0,
      inputType: 'text',
      orderId: 0,
      showWait: false,
      fee: 0,
      showHelp: false,
      qureypaymsg: '',
      errMsg: '',
      enableviewtransaction: false,
      enableviewtransactionCD: 30,
      interval: null
    }
  },
  mounted() {
    // setTimeout(() => {
    //   this.show = true
    // }, 300)
    showLoadingToast({
      message: '',
      forbidClick: true,
      duration: 0
    })
    if (this.isLogin) {
      this.requestConfig()
        .then((response) => {
          console.log('deposit.config: =>>', response)
          reportGtag(REPORT_EVENT.DEPOSIT.LOAD_COMPLETE, 'exposure')
          this.depositActivity().then((res) => {
            for (let i = 0; i < response.Configs.length; i++) {
              const element = response.Configs[i]
              this.listData.push(
                Object.assign(element, {
                  rechargeCount: res.rechargeCount,
                  rechargeConfig: res.config
                })
              )
              this.inputAmount = formatMoney(this.listData[0].amount)
            }
            this.show = true
            closeToast()
          })
        })
        .finally(() => {})
    } else {
      setTimeout(() => {
        this.show = true
        closeToast()
      }, 300)
      this.$bus.$emit(BUS.SHOW_POPUP, { from: 'deposit', to: POPUP.LOGIN, show: true })
    }
    this.$bus.$on(BUS.HIDE_DEPOSIT_IN_GAME, (res) => {
      this.showIfram = false
      this.iframUrl = ''
      this.$bus.$emit(BUS.FULL_SCREEN, false)
      this.$bus.$emit(BUS.SHOW_GAME_FOOTER, true)
      this.payStatus = res.status
      this.payAmount = res.amount
      this.qureypaymsg = res.msg
    })

    this.paymentMethods()
    setSEO(currentPage.DEPOSIT, this.country)
    if (this.from == 'first_deposit_popup') {
      this.showWait = true
      this.showHelp = true
    }
  },
  computed: {
    ...mapState(useUserStore, ['userInfo', 'country', 'isLogin', 'balance'])
  },
  methods: {
    unitConversion,
    removeThousandSeparatorWithDecimal,
    ...mapActions(useDepositStore, {
      requestConfig: 'requestConfig',
      createOrderForKE: 'createOrderForKE',
      prepay: 'prepay',
      queryPay: 'queryPay',
      depositActivity: 'depositActivity'
    }),
    ...mapActions(useUserStore, {
      updateUserInfo: 'updateUserInfo',
      paymentMethods: 'paymentMethods'
    }),
    formatMoney,
    onClose() {
      if(this.from == 'first_deposit_popup'){
        this.showWait = false
        this.showHelp = false
        this.btnState = 0
        this.show = false
        this.isFocus = false
        this.select = 0
        this.resBaseUrl = config.resBaseUrl
        this.listData = []
        this.inputAmount = ''
        this.callback()
        return
      }
      const localFrom = getLocalStorage(Key.localFrom)
      if (localFrom && localFrom !== '') {
        window.location.href = localFrom
        return
      }
      if (this.showWait) {
        this.showWait = false
        this.showHelp = false
        this.btnState = 0
      } else {
        this.show = false
        this.isFocus = false
        this.select = 0
        this.resBaseUrl = config.resBaseUrl
        this.btnState = 0
        this.listData = []
        this.inputAmount = ''
        if (this.isInGame) {
          this.$bus.$emit(BUS.CLOSE_DEPOSIT_IN_GAME)
        } else {
          this.$router.replace('/')
        }
      }
    },
    onFocus() {
      reportGtag(REPORT_EVENT.DEPOSIT.OPTIONAL_AMOUNT, 'click')
      this.isFocus = true
      this.select = -1
      this.inputAmount = removeThousandSeparatorWithDecimal(this.inputAmount)
      this.inputType = 'number'
    },
    onBlur() {
      this.isFocus = false
      this.inputType = 'text'
    },
    onUpdatePayMethod({ payChannel, paymentMethod, routing }) {
      this.bankCode = paymentMethod
      this.payChannel = payChannel
      this.routing = routing
      console.log('更新充值方式', payChannel, paymentMethod, routing)
    },
    onRecharge() {
      this.btnState = 3
      var param = {}
      if (
        this.listData.findIndex(
          (item) => item.amount == removeThousandSeparatorWithDecimal(this.inputAmount) // parseInt(this.inputAmount.replace(',', ''))
        ) > -1
      ) {
        param = Object.assign({
          rechargeRecommendId: this.listData[this.select].id,
          payChannel: this.payChannel
        })
        this.currentAmount = this.listData[this.select].fee
        this.currenReceived = this.listData[this.select].amount
      } else {
        param = Object.assign({
          fee: removeThousandSeparatorWithDecimal(this.inputAmount), //parseInt(this.inputAmount.replace(',', '')),
          payChannel: this.payChannel
        })
        this.currentAmount = param.fee
        this.currenReceived = param.fee
      }
      if (this.isInGame) {
        param.extra = 1
      } else {
        param.extra = 2
      }
      showLoadingToast({
        message: '',
        forbidClick: true,
        duration: 60000
      })
      reportGtag(REPORT_EVENT.DEPOSIT.DEPOSIT, 'click')
      this.createOrderForKE(param)
        .then(({ id, fee }) => {
          this.orderId = id
          this.fee = fee
          console.log('orderID:', id, 'fee:', fee)
          //, this.userInfo.username, this.bankCode, this.omCode
          this.showWait = true
          this.enableviewtransaction = false
          this.enableviewtransactionCD = 30
          this.interval && clearInterval(this.interval)
          this.interval = setInterval(() => {
            if (this.enableviewtransactionCD > 0) {
              this.enableviewtransactionCD--
            } else {
              this.enableviewtransaction = true
            }
          }, 1000)
          if (this.bankCode == 'OM_CI') {
            //需要otp
            this.showHelp = true
            closeToast()
          } else {
            this.reqPrepay()
            setTimeout(() => {
              closeToast()
            }, 10000)
          }
        })
        .catch((err) => {
          this.btnState = 2
          showFailToast({
            message: err,
            wordBreak: 'break-word',
            onClose: () => {
              this.btnState = 0
            }
          })
        })
    },
    reqPrepay() {
      console.log('123123123123123', {
        id: this.orderId,
        payChannel: this.payChannel,
        account: this.userInfo.username,
        bankCode: this.bankCode,
        otpCode: this.omCode
      })
      this.prepay({
        id: this.orderId,
        payChannel: this.payChannel,
        account: this.userInfo.username,
        bankCode: this.bankCode,
        otpCode: this.omCode,
        routing: this.routing
      })
        .then((response) => {
          console.log('recharge.createOrderForKE: =>>>>', response)
          this.btnState = 1
          if (this.country == 'BR') {
            this.showQRInfo = true
            this.qrCode = response.code
            this.queryOrderStatus(this.orderId)
            closeToast()
          } else {
            this.queryOrder(this.orderId)
            this.payStatus = 'PAY_PADING'
            setTimeout(() => {
              closeToast()
            }, 30000)
            if (this.routing == 'redirect') {
              SocketService.disconnect()
              window.location.href = response.payUrl // 跳出iframe，打开链接
            }
          }
        })
        .catch((err) => {
          console.log(err)
          closeToast()
        })
    },
    onTest() {
      this.btnState = 2
      setTimeout(() => {
        this.btnState = 0
      }, 1000)
    },
    queryOrderStatus(id) {
      clearTimeout(this.statusTimer)
      this.queryPay(id).then(({ status }) => {
        console.log('status: ====>>>>', status)
        if (status == 1) {
          this.statusTimer = setTimeout(() => {
            this.queryOrderStatus(id)
          }, 30000)
        } else if (status == 2) {
          this.updateUserInfo()
          this.showQRInfo = false
          this.qrCode = ''
          this.$bus.$emit(BUS.PAY_SUCCESS, { currenReceived: this.currenReceived })
        } else if (status == 3) {
          this.$bus.$emit(BUS.PAY_INVALID, { currenReceived: this.currenReceived })
        }
      })
    },
    queryOrder(id) {
      clearTimeout(this.statusTimer)
      this.queryPay(id).then(({ status }) => {
        console.log('status: ====>>>>', status)
        if (status == 1) {
          this.statusTimer = setTimeout(() => {
            this.queryOrder(id)
          }, 30000)
        }
      })
    },
    onSelectAmount(item, index) {
      this.select = index
      this.inputAmount = formatMoney(item.amount)
      this.errMsg = ''
      this.btnState = 0
      reportGtag(REPORT_EVENT.DEPOSIT[`AMOUNT_${index++}`], 'click', 'deposit', item.amount)
      airbrideg_report(AIRBRIDEG_EVENT.ADDED_TO_CART, { value: item.amount })
    },
    onCopiar() {
      copy(this.qrCode)
    },
    formatRechargeName(count) {
      const index = ['first', 'second', 'third', 'fourth']
      return this.$t(`deposit.firstDeposit.${index[count]}`)
      // let list = name.split(' ')
      // return (
      //   list[0][0].toUpperCase() + list[0].substring(1) + ' ' + this.$t('bonus.type.recharge')
      // list[1][0].toUpperCase() +
      // list[1].substring(1)
      // )
    },
    onInput(e) {
      console.log(e)
      if (parseInt(e.target.value) >= 100 && parseInt(e.target.value) <= 100000) {
        this.errMsg = ''
        this.btnState = 0
      } else {
        this.errMsg = this.$t(`deposit.limitMin.${this.country}`)
        this.btnState = 2
      }
    },
    getCurrentBonus() {
      let str = ''
      let num = removeThousandSeparatorWithDecimal(this.inputAmount)
      for (let i = 0; i < this.listData.length; i++) {
        const element = this.listData[i]
        if (element.rechargeConfig && num >= element.rechargeConfig.minimumRecharge) {
          str = Math.min(
            element.rechargeConfig.maximumReward,
            Math.round(num * element.rechargeConfig.rewardPercent) / 100
          )
        }
      }
      return str == '' ? '' : 'and get ' + str + ' Bonus'
    },
    tryagain() {
      this.payStatus = ''
      this.showWait = false
      this.onTest()
    },
    onConfitmer() {
      if (this.omCode.length > 0) {
        showLoadingToast({
          message: '',
          forbidClick: true,
          duration: 60000
        })
        if (this.from == 'first_deposit_popup') {
          this.callback(this.omCode)
        } else {
          this.reqPrepay()
        }
      }
    },
    getPayerPar() {
      let par = ''
      switch (this.bankCode) {
        case 'WAVE_CI':
          par = 'WAVE'
          break
        case 'OM_CI':
          par = 'Orange Money'
          break
        case 'MTN_CI':
          par = 'MTN'
          break
        case 'MOOV_CI':
          par = 'MOOV'
          break
        default:
          break
      }
      return par
    },
    gototrancation() {
      if (this.enableviewtransaction) {
        this.$router.replace('/transactions')
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.deposit::-webkit-scrollbar {
  height: 0;
  /* 隐藏滚动条，但保持滚动功能 */
  display: none;
}

.deposit {
  display: flex;
  padding-top: var(--user-bar-height);
  padding-bottom: var(--nav-bar-height);
  width: 100%;
  height: calc(100% - var(--user-bar-height) - var(--nav-bar-height));
  background: black;
  overflow-x: hidden;
  overflow-y: scroll;
  -ms-overflow-style: none;
  /* 隐藏滚动条，但保持滚动功能（仅针对IE和Edge） */

  .content {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
    height: calc(100vh - var(--user-bar-height) - var(--nav-bar-height));
    padding-bottom: var(--nav-bar-height);
    background-color: #ecf0f1;
    overflow-y: scroll;
    overflow-x: hidden;
    width: 90%;
    padding: 2% 5%;
    background-color: #ecf0f1;
    margin: 0;
    color: #000;
    // overflow: hidden;

    .title {
      display: flex;
      justify-content: space-between;
      align-items: center;
      width: 90%;
      height: auto;
      padding: 2% 5%;

      .left-text {
        font-size: 0.28rem !important;
        display: inline;
        line-height: 0.8rem;
        font-weight: bold;
        margin: 0px;
      }

      .close_black {
        display: block;
        width: 0.5rem;
        height: 0.05rem;
        border-radius: 0.025rem;
        background: #000;
        transform: rotate(45deg);
        // margin: 0 10%;
      }

      .close_black::after {
        content: '';
        display: block;
        width: 0.5rem;
        height: 0.05rem;
        border-radius: 0.025rem;
        background: #000;
        transform: rotate(-90deg);
      }
    }

    .dw-title {
      font-size: 0.24rem !important;
      color: #000;
      font-weight: normal;
      margin: 0.2rem 0 -0.1rem 0.2rem;
    }

    .while-card {
      width: 93.5%;
      height: auto;
      background: #d6dce1;
      // background: linear-gradient(-55deg, #ededed, #e6e6e6, #dbdbdb, #ffffff);
      border-radius: 0.16rem;
      border: 0.02px solid #bec3c7;
      padding: 3%;

      .error-message {
        margin-top: 0rem;
        font-weight: 400;
        font-size: 0.2rem;
        color: #e60012;
        line-height: 0.28rem;
        text-align: left;
        height: 0.2rem;
      }

      .inputbox {
        line-height: 0.7rem;
        background-color: #fff;
        background-image: linear-gradient(#eeeeee, #fff 15%);
        display: inline-block;
        height: 0.7rem;
        width: 94%;
        border-radius: 0.1rem;
        font-size: 0.24rem;
        // margin: 0.1rem 0 0 0;
        // padding: 0 5% 0 5%;
        margin-bottom: 0.1rem;
        border: 1px solid #bec3c7;
        margin-left: 3%;

        input {
          outline-style: none;
          outline-width: 0;
          border: none;
          border-style: none;
          text-shadow: none;
          -webkit-appearance: none;
          -webkit-user-select: text;
          outline-color: transparent;
          background-color: transparent;
          box-shadow: none;
          font-size: 0.24rem;
          line-height: 0.7rem;
          padding-left: 5%;
          width: 100%;
        }

        input::placeholder {
          color: #95a5a5;
        }
      }
    }

    .choose_amount {
      margin: 0 0 0.6rem 0.1rem;
      // padding: 0px;
      margin-bottom: 0.3rem;
      margin-top: 0.1rem;
      height: auto;
      width: 100%;
      overflow: hidden;

      .amount_active li {
        background-color: #ceb45f;
        border-top-width: 1px;
        border-right-width: 1px;
        border-bottom-width: 2px;
        border-left-width: 1px;
        border-top-style: solid;
        border-right-style: solid;
        border-bottom-style: solid;
        border-left-style: solid;
        border-top-color: #aa884a;
        border-right-color: #aa884a;
        border-bottom-color: #aa884a;
        border-left-color: #aa884a;
      }

      .amount_active li h2,
      .amount_active li h3 {
        color: #fff;
      }

      li {
        margin: 2.5% 1.45%;
        padding: 2%;
        float: left;
        width: 25%;
        height: 0.85rem;
        border-radius: 0.08rem;
        background-color: #fff;
        display: inline-block;
        border-top-width: 1px;
        border-right-width: 1px;
        border-bottom-width: 2px;
        border-left-width: 1px;
        border-top-style: solid;
        border-right-style: solid;
        border-bottom-style: solid;
        border-left-style: solid;
        border-top-color: #ceb45f;
        border-right-color: #ceb45f;
        border-bottom-color: #ceb45f;
        border-left-color: #ceb45f;
        text-align: center;
        overflow: hidden;

        i {
          font-size: 0.14rem;
          font-style: normal;
          color: #fff;
          background-color: #e84c3d;
          width: 0.8rem;
          float: right;
          margin: -0.16rem -0.42rem 0 0;
          padding: 0.09rem 0 0.01rem 0;
          display: block;
          position: relative;
          -moz-transform: rotate(45deg);
          -webkit-transform: rotate(45deg);
          -o-transform: rotate(45deg);
          -ms-transform: rotate(45deg);
          transform: rotate(45deg);
          text-align: center;
          z-index: 2;
        }

        .first-deposit {
          // width: 1.25rem;
          display: block;
          position: absolute;
          margin: -0.24rem 0 0 -0.16rem;
          height: 0.2rem;
          background: #0068b7;
          box-shadow: 0px 3px 0px 0px rgba(0, 0, 0, 0.25);
          border-radius: 0px 10px 10px 0px;
          text-align: left;
          padding-left: 0.05rem;
          padding-right: 0.15rem;
          font-family: Droid Sans;
          font-weight: 400;
          font-size: 0.18rem;
          color: #ffffff;
          line-height: 0.2rem;
          z-index: 3;
        }

        h2 {
          font-family: Oswald_Bold;
          text-align: center;
          font-size: 0.3rem;
          color: #ceb45f;
          width: 100%;
          float: left;
          padding: 0px;
          margin: -0.08rem 0 0.05rem 0;
          position: relative;
        }

        h3 {
          font-size: 0.24rem;
          line-height: 0.4rem;
          font-weight: normal;
          color: #95a5a5;
          width: max-content;
          float: left;
          margin: 0;
          text-align: center;
          display: block;
          border-top-width: 1px;
          border-top-style: solid;
          border-top-color: #d4d8d9;
          position: relative;
        }
      }
    }

    .dw_con {
      width: 90%;
      height: auto;
      margin: 0 5% 2% 5%;
      display: inline-block;

      /*矩形按钮*/
      .btn_dw_yellow,
      .btn_dw_grey,
      .btn_dw_yellow2,
      .btn_dw_greyblue {
        font-size: 0.24rem;
        line-height: 0.7rem;
        font-weight: normal;
        text-align: center;
        border-radius: 0.08rem;
      }

      .btn_dw_yellow {
        color: #fff;
        background-color: #ceb45f;
        border-top-width: 1px;
        border-bottom-width: 1px;
        border-top-style: solid;
        border-bottom-style: solid;
        border-bottom-color: #aa884a;
        border-top-color: #efe6ca;
        box-shadow: 0px 1px 0px 1px #aa884a;
        overflow: hidden;
      }

      .btn_dw_yellow:active {
        border-top-width: 4px;
        border-bottom-width: 0px;
        border-top-style: solid;
        border-bottom-style: solid;
        border-top-color: #aa884a;
      }

      .btn_dw_grey {
        color: #9b9b9b;
        background-color: #bbbebf;
        border-radius: 0.08rem;
        overflow: hidden;
        border: 1px solid #8d8d8d;
      }

      .btn_dw_yellow2 {
        background-color: #ceb45f;
        overflow: hidden;
        border: 1px solid #aa884a;
        // height: 0.6rem;
        // padding: 0.1rem 0 0;
      }

      .btn_100 {
        width: 100%;
        line-height: 0.66rem;
        text-align: center;
        // border-radius: 0.33rem;
        // margin: 0.4rem 0;
      }
    }

    .help {
      text-align: left;
      margin: 1rem 0 0;
      padding: 0.1rem 0;
      width: 100%;
      overflow: hidden;
      border-top-width: 1px;
      border-top-style: solid;
      border-top-color: #bec3c7;

      h2 {
        font-size: 0.24rem;
        font-weight: normal;
        color: #000;
        margin: -0.3rem 0 0 50%;
        padding: 0 0.1rem;
        background-color: #ecf0f1;
        display: inline;
        position: absolute;
        z-index: 2;
        left: -0.2rem;
      }

      li {
        display: inline-block;
        padding: 3%;
        height: 1rem;
        width: 93%;
        // margin: 0px;
        border-bottom-width: 1px;
        border-bottom-style: dashed;
        border-bottom-color: #bec3c7;

        h3 {
          font-size: 0.24rem;
          // margin: 0px;
          // padding: 0px;
          display: inline;
          color: #6d7f7f;
          font-weight: normal;
        }

        a {
          color: #6d7f7f;
        }

        i {
          font-size: 0.24rem;
          float: right;
          color: #bec3c7;
        }

        p {
          font-size: 0.24rem;
          // margin: 0.2rem 0;
          padding: 0px;
          color: #95a5a5;
        }
      }
    }

    .popup_footer {
      text-align: center;
      margin: 0px;
      padding: 0 0;
      height: auto;
      width: 100%;
      color: #95a5a5;

      overflow: hidden;

      a {
        text-decoration: underline;
      }

      .t_yellow {
        color: #ceb45f;
        font-size: 0.24rem;
      }
    }

    .dw_qr {
      width: 100%;
      overflow: hidden;
      margin: 0.2rem 0 0.2rem;

      .t_center {
        text-align: center !important;

        .on_center {
          margin: 0 auto !important;
        }
      }

      p {
        color: #000;
        font-size: 0.24rem;
      }

      h2 {
        font-family: Oswald_Bold;
      }
    }

    .dw_amount {
      width: 94%;
      overflow: hidden;
      border-top-width: 1px;
      border-bottom-width: 1px;
      border-top-style: solid;
      border-bottom-style: solid;
      border-top-color: #bec3c7;
      border-bottom-color: #bec3c7;
      padding: 2% 3%;
      margin: 0 0 0.5rem 0;

      li {
        width: 100%;
        padding: 1% 0;
        display: block;
        float: left;

        p {
          color: #000;
          float: left;
          display: inline;
          line-height: 0.4rem;
          font-size: 0.24rem;
        }

        h2 {
          font-family: Oswald_Bold;
          float: right;
          display: inline;
          margin: 0px;
          font-size: 0.5rem;
        }
      }
    }

    .dw_con {
      width: 90%;
      height: auto;
      margin: 0 5% 2% 5%;
      display: inline-block;
    }

    .dw_qr {
      width: 100%;
      overflow: hidden;
      margin: 0.4rem 0;

      p {
        color: #000;
      }

      h2 {
        font-family: Oswald_Bold;
        font-size: 0.24rem;
      }

      .btn_dw_yellow {
        font-size: 0.24rem;
        line-height: 0.7rem;
        font-weight: normal;
        text-align: center;
        border-radius: 0.08rem;
        color: #fff;
        background-color: #ceb45f;
        border-top-width: 1px;
        border-bottom-width: 3px;
        border-top-style: solid;
        border-bottom-style: solid;
        border-bottom-color: #aa884a;
        border-top-color: #efe6ca;
        box-shadow: 0px 1px 0px 2px #aa884a;
        overflow: hidden;
      }
    }

    .t_center {
      text-align: center !important;
    }

    .om_comtent {
      display: flex;
      justify-content: center;
      flex-direction: column;
      align-items: center;

      .om_title {
        font-family: Droid Sans;
        font-weight: bold;
        font-size: 0.25rem;
        color: #000000;
        line-height: 0.5rem;
      }

      .om_amount {
        // width: 3.43rem;
        // height: 1.01rem;
        margin-top: 0.3rem;
        font-family: Droid Sans;
        font-weight: 400;
        font-size: 0.3rem;
        color: #000000;
        line-height: 0.36rem;
      }

      .om_code {
        // width: 3.78rem;
        // height: 0.37rem;
        font-family: Droid Sans;
        font-weight: 400;
        font-size: 0.36rem;
        color: #000000;
        line-height: 0.72rem;
      }

      .om_tips {
        width: 4rem;
        height: auto;
        font-family: Droid Sans;
        font-weight: 400;
        font-size: 0.24rem;
        color: #95a5a5;
        line-height: 0.36rem;
        overflow: auto;
        text-align: center;
        margin-bottom: 0.3rem;
      }

      .om_inputbox {
        line-height: 0.7rem;
        background-color: #fff;
        background-image: linear-gradient(#eeeeee, #fff 15%);
        display: inline-block;
        height: 0.7rem;
        width: 80%;
        border-radius: 0.1rem;
        font-size: 0.24rem;
        // margin: 0.1rem 0 0 0;
        // padding: 0 5% 0 5%;
        margin-bottom: 0.2rem;
        border: 1px solid #bec3c7;

        input {
          outline-style: none;
          outline-width: 0;
          border: none;
          border-style: none;
          text-shadow: none;
          -webkit-appearance: none;
          -webkit-user-select: text;
          outline-color: transparent;
          background-color: transparent;
          box-shadow: none;
          font-size: 0.24rem;
          line-height: 0.7rem;
          padding-left: 5%;
          width: 100%;
          color: #000;
        }

        input::placeholder {
          color: #95a5a5;
        }
      }

      .om_btngroup {
        display: flex;
        justify-content: space-between;
        align-items: center;
        font-size: 0.24rem;
        color: #ffffff;
        width: 80%;

        .om_help {
          display: flex;
          justify-content: center;
          align-items: center;
          width: 1.6rem;
          height: 0.7rem;
          background: #95a5a5;
          box-shadow:
            0rem 0rem 0rem 0rem #778989,
            0rem 0rem 0rem 0rem #778989;
          border-radius: 0.06rem;
          margin-right: 0.36rem;
        }

        .om_confirm {
          display: flex;
          justify-content: center;
          align-items: center;
          width: 3.61rem;
          height: 0.7rem;
          background: #bbbebf;
          box-shadow: 0rem 0rem 0rem 0rem #8d8d8d;
          border-radius: 0.08rem;
        }

        .om_active_confirm {
          display: flex;
          justify-content: center;
          align-items: center;
          width: 3.61rem;
          height: 0.7rem;
          background: #ceb45f;
          box-shadow:
            0rem 0rem 0rem 0rem #aa884a,
            0rem 0rem 0rem 0rem #aa884a;
          border-radius: 0.08rem;
        }
      }

      .transaction_btn {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 5.56rem;
        height: 0.7rem;
        background: #ceb45f;
        box-shadow:
          0rem 0rem 0rem 0rem #aa884a,
          0rem 0rem 0rem 0rem #aa884a;
        border-radius: 0.08rem;

        font-family: Droid Sans;
        font-weight: 400;
        font-size: 0.24rem;
        color: #ffffff;
      }

      .grey_transaction_btn {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 5.56rem;
        height: 0.7rem;
        border-radius: 0.08rem;

        font-family: Droid Sans;
        font-weight: 400;
        font-size: 0.24rem;

        color: #9b9b9b;
        background-color: #bbbebf;
        border: 2px solid #8d8d8d;
      }
    }
  }

  .popup_box {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    flex-direction: column;
    width: 5rem;
    height: 4rem;
    background: #ecf0f1;
    border-radius: 0.16rem;
    padding: 0.31rem;
    margin-top: -2rem;

    .popup_title {
      height: 0.31rem;
      font-family: Droid Sans;
      font-weight: 400;
      font-size: 0.3rem;
      color: #000000;
    }

    .popup_content {
      height: 1.33rem;
      font-family: Droid Sans;
      font-weight: 400;
      font-size: 0.24rem;
      color: #000000;
      line-height: 0.36rem;
      margin-top: 0.33rem;
    }

    .popup_btn {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 4.36rem;
      height: 0.7rem;
      margin-top: 0.41rem;
      background: #ceb45f;
      box-shadow:
        0rem 0rem 0rem 0rem #aa884a,
        0rem 0rem 0rem 0rem #aa884a;
      border-radius: 0.08rem;

      font-family: Droid Sans;
      font-weight: 400;
      font-size: 0.24rem;
      color: #ffffff;
    }
  }
}
</style>
